import { render, staticRenderFns } from "./contentBlock.vue?vue&type=template&id=e0be1684&scoped=true&"
import script from "./contentBlock.vue?vue&type=script&lang=js&"
export * from "./contentBlock.vue?vue&type=script&lang=js&"
import style0 from "./contentBlock.vue?vue&type=style&index=0&id=e0be1684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0be1684",
  null
  
)

export default component.exports